import Keycloak from "keycloak-js";
import {
  KEYCLOAK_CHECK_LOGIN_IFRAME,
  KEYCLOAK_ENABLED,
  KEYCLOAK_CLIENT_ID,
  KEYCLOAK_REALM,
  KEYCLOAK_URL
} from "../env";

function ensureRandomUuid() {
  if (
    typeof window === "undefined" ||
    typeof window.crypto === "undefined" ||
    typeof window.crypto.randomUUID === "function" ||
    typeof window.crypto.getRandomValues !== "function"
  ) {
    return;
  }

  window.crypto.randomUUID = () => {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);

    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const hex = Array.from(bytes, (byte) =>
      byte.toString(16).padStart(2, "0")
    ).join("");

    return [
      hex.slice(0, 8),
      hex.slice(8, 12),
      hex.slice(12, 16),
      hex.slice(16, 20),
      hex.slice(20, 32)
    ].join("-");
  };
}

ensureRandomUuid();

const disabledKeycloak = {
  authenticated: false,
  token: null,
  tokenParsed: null,
  idTokenParsed: null,
  login: async () => {
    throw new Error("A autenticação do Keycloak está desabilitada.");
  },
  logout: async () => undefined,
  updateToken: async () => false
};

const keycloak = KEYCLOAK_ENABLED
  ? new Keycloak({
      url: KEYCLOAK_URL,
      realm: KEYCLOAK_REALM,
      clientId: KEYCLOAK_CLIENT_ID
    })
  : disabledKeycloak;

export const getToken = () => keycloak.token;

function getClientRoles() {
  const resourceAccess = keycloak?.tokenParsed?.resource_access || {};
  return resourceAccess?.[KEYCLOAK_CLIENT_ID]?.roles || [];
}

export const getUserRoles = () => [...new Set(getClientRoles())];

export const isUserInRole = (role) => getUserRoles().includes(role);

export async function updateToken(minValidity = 5) {
  if (!KEYCLOAK_ENABLED || !keycloak.authenticated) {
    return false;
  }
  return keycloak.updateToken(minValidity);
}

export async function initKeycloak({ initialize = true } = {}) {
  if (!initialize) {
    return false;
  }
  if (!KEYCLOAK_ENABLED) {
    throw new Error("O Keycloak precisa estar habilitado para acessar a administração.");
  }

  const insecureContext =
    typeof window !== "undefined" && window.isSecureContext === false;

  return keycloak
    .init({
      onLoad: "login-required",
      checkLoginIframe: KEYCLOAK_CHECK_LOGIN_IFRAME,
      pkceMethod: insecureContext ? false : "S256",
      enableLogging: true
    })
    .then((authenticated) => {
      if (!authenticated) {
        throw new Error("O Keycloak não confirmou a autenticação do usuário.");
      }
      setInterval(
        () => keycloak.updateToken(30).catch(console.error),
        25 * 1000
      );
      return true;
    });
}

export default keycloak;
